import $ from 'jquery';
import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

$(document).ready(function () {
    Fancybox.bind("[data-fancybox]", {
        dragToClose: false,
        Carousel: {
            Toolbar: {
                display: {
                    left: [
                        //"counter"
                    ],
                    middle: [
                        //"zoomIn",
                        //"zoomOut",
                        //"toggle1to1",
                        //"rotateCCW",
                        //"rotateCW",
                        //"flipX",
                        //"flipY",
                        //"reset",
                    ],
                    right: [
                        //"autoplay",
                        //"thumbs",
                        "close"
                    ],
                },
            },
            //Thumbs: false,
            transition: "slide",
            breakpoints: {
                "(min-width: 1120px)": {
                    transition: "fade",
                }
            }
        }
    });


    Fancybox.bind('[data-fancybox="projectsGallery"]', {
        dragToClose: false,
        Carousel: {
            Thumbs: false,
            Arrows: false,
            transition: "slide",
            breakpoints: {
                "(min-width: 1120px)": {
                    transition: "fade",
                }
            }
        }
    });
})